import { ProductRequestListPage } from "@/features/consignment-product-request/pages/ProductRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-product-request/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view", "vendor_consignment.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductRequestListPage,
});
